import { render } from "./PartnerRegistrationAdd.vue?vue&type=template&id=cb9e8710&scoped=true"
import script from "./PartnerRegistrationAdd.vue?vue&type=script&lang=js"
export * from "./PartnerRegistrationAdd.vue?vue&type=script&lang=js"

import "./PartnerRegistrationAdd.vue?vue&type=style&index=0&id=cb9e8710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9e8710"]])

export default __exports__